import { FaNetworkWired, FaLightbulb, FaChalkboardTeacher } from 'react-icons/fa';

const whyAttend = {
    sub: "Why Attend This Conference",
    heading: "Your Gateway to Networking and Knowledge",
    content: "Join us at our upcoming conference, where you can expand your knowledge, network with industry leaders, and gain valuable insights that can elevate your professional journey.",
    points: [
        {
            id: 1,
            icon: <FaNetworkWired />, // Network icon
            title: 'Networking Opportunities',
            content: 'Connect with professionals and peers from your industry to build valuable relationships.',
        },
        {
            id: 2,
            icon: <FaLightbulb />, // Lightbulb icon
            title: 'Expert Speakers',
            content: 'Learn from industry experts and thought leaders who share their insights and experiences.',
        },
        {
            id: 3,
            icon: <FaChalkboardTeacher />, // Teacher icon
            title: 'Workshops & Sessions',
            content: 'Participate in interactive workshops that provide hands-on experience and practical skills.',
        },
    ]
}

export default whyAttend;